import React from 'react';
import Menu from './Menu.js';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FileGeneration from './FileGenerator.js';
import FileTransformator from './FileTransformator.js';

const MainPage = () => {
  return (
    <Router>
      <div>
        <Menu />
        <Routes>
          <Route path="/" element={<FileGeneration />} />
          <Route path="/FileGeneration" element={<FileGeneration />} />
          <Route path="/FileTransformator" element={<FileTransformator />} />
        </Routes>
      </div>
    </Router>
  );
};

export default MainPage;